import { types } from 'mobx-state-tree';

export const ConversationsParams = types
  .model('ConversationsParams', {
    limit: types.optional(types.number, 20),
    offset: types.optional(types.number, 0),
    is_archived: types.optional(types.boolean, false),
    only_unread: types.optional(types.boolean, false),
  })
  .views((self) => ({
    //...
  }))
  .actions((self) => ({
    increaseOffset() {
      self.offset = self.offset + self.limit;
    },
    decreaseOffset() {
      //TODO: Скорей всего не нужно
      if (self.limit > self.offset) {
        return;
      }
      self.offset = self.offset - self.limit;
    },
    clearOffset() {
      self.offset = 0;
    },
    changeListType(isArchive?: boolean) {
      self.is_archived = isArchive ?? !self.is_archived;
    },
    changeReadFlag(value?: boolean) {
      self.only_unread = value ?? !self.only_unread;
    },
  }));
